import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_CONFIG_SYS_TMTC,
  SHOW_FORM_TIN_CHAP,
  POST_TIN_CHAP,
  CHECK_EDIT_CUSTOMER_TC,
  CHECK_EDIT_TIN_CHAP,
  GET_TAI_SAN_THEO_CHO_VAY_TMTC,
} from "actions/ThemMoiTinChap/actionTypes";
import {
  postTinChapFailure,
  postTinChapSuccess,
  checkEditChoVay as a_checkEditChoVay,
  setEnableEditChoVay,
  setEnableEditCustomer,
  getTaiSanTheoChoVayTMTC as a_getTaiSanTheoChoVayTMTC,
  getConfigSysTMTC,
  setTaiSanTinChap,
} from "actions/ThemMoiTinChap";
import { pushNotification } from "utils/notifications";
import { setConfig } from "actions/ThemMoiTinChap";
import CauHinhApi from "service/cauHinhApi";
import { getListPhiKhac, getListPhiKhacTheoChoVay } from "actions/PhiKhac";
import { getListPhiKhacHangKy, getListPhiKhacHangKyTheoChoVay } from "actions/PhiKhacHangKy";
import { getComboNguonKhachHang } from "actions/NguonKhachHang";
import TinChapApi from "service/tinChapApi";
import CamDoApi from "service/camDoApi";
import CustomerApi from "service/customerApi";
import TaiSanApi from "service/taiSanApi";

function* showFormTinChap(action) {
  try {
    yield put(getComboNguonKhachHang());
    let chovay = action.payload;
    if (chovay && chovay.ChoVayId) {
      yield put(a_checkEditChoVay(chovay.ChoVayId));
      yield put(
        getListPhiKhacTheoChoVay({
          chovayId: chovay.ChoVayId,
          typeChoVay: chovay.Type,
        })
      );
      yield put(
        getListPhiKhacHangKyTheoChoVay({
          chovayId: chovay.ChoVayId,
          typeChoVay: chovay.Type,
        })
      );
      yield put(a_getTaiSanTheoChoVayTMTC({ chovayId: chovay.ChoVayId }));
    } else {
      yield put(getListPhiKhac({ type: 1 }));
      yield put(getListPhiKhacHangKy({ type: 1 }));
    }
    yield put(
      getConfigSysTMTC({
        loaiTaiSan: "",
      })
    );
  } catch (error) {}
}
function* getTaiSanTheoChoVayTMTC(action) {
  try {
    const response = yield call(TaiSanApi.taiSanTheoChoVay, action.dataSearch);
    if (response.ok && response.data) {
      let lstCamDo = response.data;
      if (lstCamDo.length > 0) {
        yield put(setTaiSanTinChap(lstCamDo[0]));
      }
    } else {
      pushNotification(
        "Không tải được thông tin tài sản cầm cố.",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  } catch (error) {
    pushNotification(
      "Không tải được thông tin tài sản cầm cố.",
      "error",
      "TOP_CENTER",
      1000
    );
  }
}
function* getConfigSysThemMoiTinChap(action) {
  try {
    const response = yield call(
      CauHinhApi.getConfigSys_LoaiTaiSan,
      action.dataSearch
    );
    if (response.ok && response.data) {
      yield put(setConfig(response.data));
    }
  } catch (error) {
    console.log(error);
  }
}
function* postTinChap(action) {
  try {
    const response = yield call(TinChapApi.addAndEdit, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        yield put(postTinChapFailure(response.data));
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
      } else {
        yield put(postTinChapSuccess(response.data));
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(postTinChapFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(postTinChapFailure());
  }
}

function* checkEditChoVay(action) {
  try {
    const response = yield call(CamDoApi.checkEditChoVay, action.choVayId);
    if (response.ok) {
      yield put(setEnableEditChoVay(response.data));
    } else {
      console.log(response);
    }
  } catch (error) {
    console.log(error);
  }
}
function* checkEditCustomer(action) {
  try {
    const response = yield call(
      CustomerApi.checkEditCustomer,
      action.customerId
    );
    if (response.ok) {
      yield put(setEnableEditCustomer(response.data));
    } else {
      console.log(response);
    }
  } catch (error) {
    console.log(error);
  }
}
function* watchGetRequest() {
  yield takeLatest(GET_CONFIG_SYS_TMTC, getConfigSysThemMoiTinChap);
  yield takeLatest(SHOW_FORM_TIN_CHAP, showFormTinChap);
  yield takeLatest(POST_TIN_CHAP, postTinChap);
  yield takeLatest(CHECK_EDIT_TIN_CHAP, checkEditChoVay);
  yield takeLatest(CHECK_EDIT_CUSTOMER_TC, checkEditCustomer);
  yield takeLatest(GET_TAI_SAN_THEO_CHO_VAY_TMTC, getTaiSanTheoChoVayTMTC);
  //GET_TAI_SAN_THEO_CHO_VAY_TMTC
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
